import {
  getApiV1ThreeLetterCodeClientAdminsUsersId,
  getGetApiV1ThreeLetterCodeClientAdminsUsersIdKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type { GetApiV1ThreeLetterCodeClientAdminsUsersId200 } from '@fukuri-admins/apis/client/gen/model';
import { useFetch } from '@fukuri-admins/hooks/common';

type Args = {
  threeLetterCode: string;
  id: number;
};

type IUseGetClientUser = (args: Args) => {
  data: GetApiV1ThreeLetterCodeClientAdminsUsersId200;
};

/**
 * 利用者詳細取得フック
 */
export const useGetClientUser: IUseGetClientUser = ({ threeLetterCode, id }) => {
  const { data } = useFetch(
    getGetApiV1ThreeLetterCodeClientAdminsUsersIdKey(threeLetterCode, id),
    () => getApiV1ThreeLetterCodeClientAdminsUsersId(threeLetterCode, id),
    { suspense: true }
  );

  return { data };
};
